module.exports = __webpack_public_path__ + "media/images/Snack-833414c08b86fefd0b249f9f12fbdd18.svg";